import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable()
export class SemsoSnackbarService {

  constructor(private snackbar: MatSnackBar) { }

  error(message: string) {
    this.snackbar.open(message, 'Sluit', {
      duration: 5000,
      panelClass: 'error-snackbar'
    });
  }

  success(message: string) {
    this.snackbar.open(message, 'Sluit', {
      duration: 5000,
      panelClass: 'success-snackbar'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/semso-snackbar.service.ts